export default __webpack_public_path__ + "static/media/vehicle60.afc0f2b8.svg";